import { motion, useAnimation, useInView } from 'framer-motion';
import React, { useRef } from 'react';
import './footer.css';

const Footer = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { 
    once: false,
    threshold: 0.2
  });
  const controls = useAnimation();

  React.useEffect(() => {
    if (isInView) {
      controls.start('visible');
    }
  }, [isInView, controls]);

  const containerVariants = {
    hidden: { 
      opacity: 0,
      y: 50
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { 
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <motion.div 
      className="footer"
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={containerVariants}
    >
      <div className="footer__container container">
        <motion.h1 
          className="footer__title"
          variants={itemVariants}
        >
          Alvin.
        </motion.h1>

        <motion.ul 
          className='footer__list'
          variants={itemVariants}
        >
          <li>
            <a href="#about" className="footer__link">About</a>
          </li>
          <li>
            <a href="#portfolio" className="footer__link">Project</a>
          </li>
          <li>
            <a href="#testimonials" className="footer__link">Testimonials</a>
          </li>
        </motion.ul>

        <motion.div 
          className="footer__social"
          variants={itemVariants}
        >
          <motion.a 
            href="https://www.facebook.com/profile.php?id=61555979974234" 
            className="footer__social-link" 
            target="_blank" 
            rel="noopener noreferrer"
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.9 }}
          >
            <i className="uil uil-facebook"></i>
          </motion.a>
          <motion.a 
            href="https://instagram.com/qalvinahmad" 
            className="footer__social-link" 
            target="_blank" 
            rel="noopener noreferrer"
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.9 }}
          >
            <i className="uil uil-instagram"></i>
          </motion.a>
          <motion.a 
            href="https://twitter.com/qalvinahmad" 
            className="footer__social-link" 
            target="_blank" 
            rel="noopener noreferrer"
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.9 }}
          >
            <i className="uil uil-twitter"></i>
          </motion.a>
          <motion.a 
            href="https://youtube.com/@qalvinahmad" 
            className="footer__social-link" 
            target="_blank" 
            rel="noopener noreferrer"
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.9 }}
          >
            <i className="uil uil-youtube"></i>
          </motion.a>
        </motion.div>

        <motion.span 
          className="footer__copy"
          variants={itemVariants}
        >
          &#169; Alvin {new Date().getFullYear()}. All rights reserved
        </motion.span>
      </div>
    </motion.div>
  )
}

export default Footer